module.exports = __webpack_public_path__ + "img/8.31b5e9b0.png";